/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A pending tournament invitation
 * @export
 * @interface TournamentInvitationEntryResponse
 */
export interface TournamentInvitationEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof TournamentInvitationEntryResponse
     */
    invitationId: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentInvitationEntryResponse
     */
    tournamentId: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentInvitationEntryResponse
     */
    tournamentName: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentInvitationEntryResponse
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentInvitationEntryResponse
     */
    teamName: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentInvitationEntryResponse
     */
    invitedBy: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentInvitationEntryResponse
     */
    invitedAt: number;
}

/**
 * Check if a given object implements the TournamentInvitationEntryResponse interface.
 */
export function instanceOfTournamentInvitationEntryResponse(value: object): value is TournamentInvitationEntryResponse {
    if (!('invitationId' in value) || value['invitationId'] === undefined) return false;
    if (!('tournamentId' in value) || value['tournamentId'] === undefined) return false;
    if (!('tournamentName' in value) || value['tournamentName'] === undefined) return false;
    if (!('teamId' in value) || value['teamId'] === undefined) return false;
    if (!('teamName' in value) || value['teamName'] === undefined) return false;
    if (!('invitedBy' in value) || value['invitedBy'] === undefined) return false;
    if (!('invitedAt' in value) || value['invitedAt'] === undefined) return false;
    return true;
}

export function TournamentInvitationEntryResponseFromJSON(json: any): TournamentInvitationEntryResponse {
    return TournamentInvitationEntryResponseFromJSONTyped(json, false);
}

export function TournamentInvitationEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentInvitationEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'invitationId': json['invitationId'],
        'tournamentId': json['tournamentId'],
        'tournamentName': json['tournamentName'],
        'teamId': json['teamId'],
        'teamName': json['teamName'],
        'invitedBy': json['invitedBy'],
        'invitedAt': json['invitedAt'],
    };
}

export function TournamentInvitationEntryResponseToJSON(json: any): TournamentInvitationEntryResponse {
    return TournamentInvitationEntryResponseToJSONTyped(json, false);
}

export function TournamentInvitationEntryResponseToJSONTyped(value?: TournamentInvitationEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invitationId': value['invitationId'],
        'tournamentId': value['tournamentId'],
        'tournamentName': value['tournamentName'],
        'teamId': value['teamId'],
        'teamName': value['teamName'],
        'invitedBy': value['invitedBy'],
        'invitedAt': value['invitedAt'],
    };
}

